<template>
    <div class="tarjeta-noticia" :class="clase">
        <Link :href="'/noticia/'+item.slug" class="tarjeta-noticia__img">
            <img :src="(portada)? item.portada.medium: item.portada.small" :alt="item.titulo" width="350" height="230" loading="lazy" />
        </Link>
        <div class="tarjeta-noticia__footer">
            <div class="tarjeta-noticia__info">
            <h4><Link :href="'/noticia/'+item.slug">{{  (truncate)? $filters.truncate(item.titulo, 30, '...') : item.titulo  }}</Link></h4>
            <div class="tarjeta-noticia__fecha">{{  $filters.getFullDate(item.created_at)  }}</div>
            </div>

            <Link :href="'/noticia/'+item.slug" class="tarjeta-noticia__link">Ver más</Link>
        </div>
    </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
export default {
    components:{ Link },
    props:{
        item: Object,
        clase: String,
        truncate: Boolean,
        portada: Boolean,
    }
}
</script>
<style>
h4{
    margin-top: 0;
    line-height: 1.3em;
}
</style>
